import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { ReactComponent as Logo } from '../../assets/svg/logo.svg'
import { Link } from 'react-router-dom'

function GlobalHeader({ noLink }) {
  const logo = (() => {
    if (noLink) {
      return (
        <LogoWrapper>
          <Logo />
        </LogoWrapper>
      )
    }

    return (
      <Link to="/service">
        <LogoWrapper>
          <Logo />
        </LogoWrapper>
      </Link>
    )
  })()

  return <Wrapper>{logo}</Wrapper>
}

const Wrapper = styled.div``

const LogoWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 55px;
`

GlobalHeader.propTypes = {
  noLink: PropTypes.bool,
}

export default GlobalHeader
